module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/banner/en-a8259473acb24479c62cf01f276959a7.jpg";